function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import OptionNestedPickerField from './optionNestedPicker/optionNestedPicker';
import Label from './label';
import { enabledSelector, newPathSelector, valueSelector } from '../selectors/index';
import logValueOnChange from '../commonActions/logValueOnChange';
import { leafPedigreesString } from '../../../../behaviors/src/lib/common';
import { removeNulls } from '../../../utils/contentTools';
const buildTree = (list, others = []) => {
  const parsedOthers = others.map(other => ({
    identifier: other.id,
    name: other.name,
    sectionName: 'Other'
  }));
  const tree = [];
  list.concat(parsedOthers).forEach(piece => {
    let parent = tree.find(existingPiece => existingPiece.title === piece.sectionName);
    if (!parent) {
      parent = {
        _created: tree.length,
        title: piece.sectionName,
        identifier: `_${piece.sectionName}`,
        options: []
      };
      tree.push(parent);
    }
    parent.options.push({
      _created: piece.sortOrder,
      identifier: piece.identifier,
      title: piece.name
    });
  });
  return tree;
};
const PiecesPickerField = ({
  pieceComponentReport: {
    list,
    initialIndexQuery
  },
  pieceComponentReportActions: {
    serverIndex
  },
  pieceOtherComponent: {
    list: otherList,
    initialIndexQuery: otherInitialIndexQuery
  },
  pieceOtherComponentActions: {
    serverIndex: otherServerIndex
  },
  jobID,
  value: _value = {},
  onChange,
  enabled: _enabled = true,
  label: _label = null,
  path
}) => {
  const wrappedOnChange = ({
    value: tree,
    changeModifiers
  }) => {
    const displayValue = leafPedigreesString(removeNulls(tree));
    onChange({
      path,
      value: tree,
      displayValue,
      changeModifiers
    });
  };
  useEffect(() => {
    serverIndex(_objectSpread(_objectSpread({}, initialIndexQuery), {}, {
      jobID
    }));
    otherServerIndex(_objectSpread(_objectSpread({}, otherInitialIndexQuery), {}, {
      jobID
    }));
  }, [serverIndex, initialIndexQuery, otherServerIndex, otherInitialIndexQuery, jobID]);
  const options = useMemo(() => buildTree(list, otherList), [list, otherList]);
  return /*#__PURE__*/React.createElement("div", null, _label ? /*#__PURE__*/React.createElement(Label, {
    value: _label
  }) : null, /*#__PURE__*/React.createElement(OptionNestedPickerField, {
    label: _label,
    options: options,
    enabled: _enabled,
    value: _value,
    allowsMultipleSelection: true,
    onChange: wrappedOnChange
  }));
};
PiecesPickerField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.shape({}),
  enabled: PropTypes.bool,
  jobID: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  pieceComponentReportActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  pieceComponentReport: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    initialIndexQuery: PropTypes.shape({})
  }).isRequired,
  pieceOtherComponentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  pieceOtherComponent: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    initialIndexQuery: PropTypes.shape({})
  }).isRequired
};
export { PiecesPickerField as UncomposedPiecesPickerField };
export default entityComposition(PiecesPickerField, ['pieceComponentReport', 'pieceOtherComponent'], {
  jobID: state => state.report.active.Job.id,
  value: valueSelector,
  enabled: enabledSelector,
  path: newPathSelector,
  onChange: logValueOnChange
});